export type PriceTargetTypes = 'PRODUCT' | 'APLUS' | 'ATB' | 'INSTALLMENTCALCULATOR';

/**
 * This method returns an Integer (in cents) price value based on the target type.
 * This is necessary because some target types (e.g. APLUS) expect the price value to be in a different format (e.g. in cents instead of euros).
 *
 * if no target type is provided it will use the shop default which is the price as Integer (in cents)
 *
 * @param price the price value to be formatted
 * @param targetType the target type for which the price value should be formatted
 * @returns the formatted price value based on the target type as Integer (in cents)
 */
export const getIntegerPriceValueByTargetType = (price: number, targetType: PriceTargetTypes) => {
  switch (targetType) {
    case 'APLUS':
    case 'INSTALLMENTCALCULATOR': {
      return Math.round(price * 100);
    }
    case 'PRODUCT':
    case 'ATB':
    default: {
      return price;
    }
  }
};

/**
 * This method returns a float (in euros) price value based on the target type.
 * This is necessary because some target types (e.g. APLUS) expect the price value to be in a different format (e.g. in cents instead of euros).
 *
 * if no target type is provided it will use the shop default which is the price as Integer (in cents)
 *
 * @param price the price value to be formatted
 * @param targetType the target type for which the price value should be formatted
 * @returns the formatted price value based on the target type as Float (in euros)
 */
export const getFloatPriceValueByTargetType = (price: number, targetType: PriceTargetTypes) => {
  switch (targetType) {
    case 'APLUS':
    case 'INSTALLMENTCALCULATOR': {
      return price;
    }
    case 'PRODUCT':
    case 'ATB':
    default: {
      return price / 100;
    }
  }
};
